import { http } from "helpers/Http";
import { IExistingTablesCallResponse, ITableCallParams, ITableCallResponse } from "types/Tables";
import logger from "components/Logger"

export async function postAddTableCall(
    params: ITableCallParams
  ): Promise<ITableCallResponse> {
    const url = `tables/new`;
    const data = http
      .post(url, {
        place_id: params.place_id,
        table_number: params.table_number,
        calling: params.calling
      })
      .then((response) => response.data);
    return data;
  }

  export async function getExistingTables( placeId: number) : Promise<IExistingTablesCallResponse> {
  const url = `places/${placeId}/getexistingtables`
    const data = http.get(url)
      .then(r => {
        //console.log('existing tables response', r)
        //console.log('existing tables data', r.data.data.existing_tables_json_list)
              r.data.data.existing_tables_json_list =
          JSON.parse(r.data.data.existing_tables_json_list)
        return r.data
      })

    logger.log('getExistingTables PROMISE: ', data)

    return data;
  }